import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { BusinessPagePrefetchedDataProps } from 'src/app/pages/about/business/pageContext';
import { BusinessPageContextProvider, prefetchPageContext } from 'src/app/pages/about/business/pageContext';
import { isLoaded } from 'src/app/shared/utils/async';

import { Layout } from '../layout';

import { BusinessErrorHandler } from './ErrorHandler';

export const Business = withPrefetchedData(
	function Business({ prefetchedData }: BusinessPagePrefetchedDataProps) {
		return (
			<BusinessPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={BusinessErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</BusinessPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,

		prefetchData: async (context) => prefetchPageContext(context),
		pageTitle: ({ prefetchedData, fromTemplate }) => {
			if (!isLoaded(prefetchedData.pageData)) {
				return undefined;
			}
			return fromTemplate(prefetchedData.pageData.pageData.title);
		},
		pageMetadata: ({ prefetchedData, i18n }) => {
			if (!isLoaded(prefetchedData.pageData)) {
				return {};
			}
			const description = i18n.translate('fe.pages.about_business_model.description');
			return {
				description,
				ogDescription: description,
				ogTitle: prefetchedData.pageData.pageData.title,
				ogType: 'website',
				twitterCard: 'summary',
			};
		},
	},
);
